export type ThemeMode = 'light' | 'dark'
export type ThemeColor = 'red' | 'blue' | 'green' | 'orange' | 'primary'

export interface ThemeTokens {
  colorPrimary: string
  colorInfo: string
  components: any
}

const RED_THEME: ThemeTokens = {
  colorPrimary: '#fa2b06',
  colorInfo: '#fa2b06',
  components: {
    Button: {
      colorPrimary: 'rgb(245,34,45)',
      colorPrimaryActive: 'rgb(255,0,13)',
      colorPrimaryHover: 'rgb(255,0,13)',
    },
    Menu: {
      itemSelectedColor: 'rgb(245,34,45)',
      itemSelectedBg: 'rgb(255,232,233)',
      subMenuItemSelectedColor: 'rgb(245,34,45)',
      itemActiveBg: 'rgb(255,222,224)',
    },
    Table: {
      headerBg: 'rgb(245,34,45)',
      headerFilterHoverBg: 'rgb(248,101,108)',
      headerSortActiveBg: 'rgb(245,34,45)',
      headerSortHoverBg: 'rgb(255,134,134)',
      colorPrimaryBorder: 'rgb(245,34,45)',
    },
    Pagination: {
      colorPrimary: 'rgb(245,34,45)',
    },
  },
}

const BLUE_THEME: ThemeTokens = {
  colorPrimary: '#1677ff',
  colorInfo: '#1677ff',
  components: {
    Button: {
      colorPrimary: '#1677ff',
      colorPrimaryActive: '#0958d9',
      colorPrimaryHover: '#4096ff',
    },
    Menu: {
      itemSelectedColor: '#1677ff',
      itemSelectedBg: '#e6f4ff',
      subMenuItemSelectedColor: '#1677ff',
      itemActiveBg: '#e6f4ff',
    },
    Table: {
      headerBg: '#1677ff',
      headerFilterHoverBg: '#4096ff',
      headerSortActiveBg: '#1677ff',
      headerSortHoverBg: '#69b1ff',
      colorPrimaryBorder: '#1677ff',
    },
    Pagination: {
      colorPrimary: '#1677ff',
    },
  },
}

const GREEN_THEME: ThemeTokens = {
  colorPrimary: '#52c41a',
  colorInfo: '#52c41a',
  components: {
    Button: {
      colorPrimary: '#52c41a',
      colorPrimaryActive: '#389e0d',
      colorPrimaryHover: '#73d13d',
    },
    Menu: {
      itemSelectedColor: '#52c41a',
      itemSelectedBg: '#f6ffed',
      subMenuItemSelectedColor: '#52c41a',
      itemActiveBg: '#f6ffed',
    },
    Table: {
      headerBg: '#52c41a',
      headerFilterHoverBg: '#73d13d',
      headerSortActiveBg: '#52c41a',
      headerSortHoverBg: '#95de64',
      colorPrimaryBorder: '#52c41a',
    },
    Pagination: {
      colorPrimary: '#52c41a',
    },
  },
}

const ColorPrimary = '#00786f'
const ColorPrimaryDefault = '#ffffff'
const PRIMARY_THEME: ThemeTokens = {
  colorPrimary: ColorPrimary,
  colorInfo: ColorPrimary,
  components: {
    Menu: {
      fontSize: 12,
      iconMarginInlineEnd: 8,
      iconSize: 20,
      itemActiveBg: 'rgb(216, 237, 236)',
      colorPrimaryBorder: 'rgb(141,253,245)',
      itemSelectedBg: 'rgb(217, 237, 236)',
      collapsedIconSize: 18,
      itemPaddingInline: 12,
      itemMarginInline: 4,
    },
    Button: {
      defaultBg: ColorPrimaryDefault,
      borderRadius: 10,
      borderRadiusLG: 10,
      lineWidth: 2,
      lineWidthFocus: 3,
      controlHeight: 32,
      controlHeightLG: 44,
      controlHeightSM: 28,
      primaryShadow: 'none',
      fontWeight: 600,
    },
    Input: {
      controlHeight: 32,
      activeShadow: '0',
      errorActiveShadow: '0',
      warningActiveShadow: '0',
    },
    Select: {
      controlHeight: 36,
    },
    DatePicker: {
      controlHeight: 36,
    },
    Table: {
      headerColor: ColorPrimaryDefault,
      headerBg: ColorPrimary,
      cellPaddingInline: 12,
      cellPaddingBlock: 8,
      headerBorderRadius: 4,
      borderRadius: 4,
      fontSize: 12,
    },
    Collapse: {
      headerBg: 'rgb(242,141,64)',
      colorTextHeading: 'rgba(255,255,255,0.88)',
      marginSM: 'calc(40% + 24px)',
      borderRadiusLG: 20,
    },
    Tooltip: {
      colorBgSpotlight: 'rgba(255,255,255)',
      colorText: 'rgba(255,255,255)',
      colorTextLightSolid: 'rgb(15, 154, 115)',
    },
  },
}
export const THEME_CONFIG: Record<ThemeColor, ThemeTokens> = {
  red: RED_THEME,
  orange: RED_THEME, // Alias for backward compat if needed
  blue: BLUE_THEME,
  green: GREEN_THEME,
  primary: PRIMARY_THEME,
}
